import React, {Component}                       from "react";
import {ImageBackground, FlatList, Text, View}  from "react-native";
import {connect}                                from "react-redux";
import Modal                                    from "./Modal";
import Button                                   from "../Button";
import * as Actions                             from "../../constants/Actions";
import styles                                   from "../../styles/Styles";

class ModalHistory extends Component {
    render() {
        return (
           <View>
                <Modal animationType={"fade"} onRequestClose={null} supportedOrientations={["landscape"]} transparent={true}
                    visible={this.props.showHistory}>
                    {/* Modal Background is a hack to dim the screen behind the modal */}
                    <View style={styles.modalBackground}>
                        <View style={styles.modalDialog}>
                            <ImageBackground source={require("../../../assets/clapboard_temp.png")} style={styles.backgroundModal} imageStyle={styles.backgroundImageStretch}>
                                <View style={styles.modalDialogInner}>
                                    {/* Header Row */}
                                    <View style={styles.modalDetailRow}>
                                        <Text style={styles.modalDetailText}>Movie</Text>
                                        <Text style={styles.modalDetailText}>Winner</Text>
                                    </View>
                                    <View style={styles.lineHorizontalModal} />

                                    {/* Round Results */}
                                    <FlatList data={this.props.roundTracker} keyExtractor={(item, index) => "" + index} renderItem={({item}) => 
                                        <View style={styles.modalDetailRow}>
                                            <Text style={styles.modalDetailText}>{item.movie}</Text>
                                            <Text style={styles.modalDetailText}>{item.winner}</Text>
                                        </View>
                                    }/>
                                    
                                    <View style={styles.lineHorizontalModal} />
                                    <View style={styles.modalButtonPanel}>
                                        <Button onPress={this.props.dismissHistory} text="Hide History" />
                                    </View>
                                </View>
                            </ImageBackground>
                        </View>
                    </View>
                </Modal>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        roundTracker:   state.roundTracker,
        showHistory:    state.showHistory
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        dismissHistory: () => { dispatch({type: Actions.SHOW_HISTORY}) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalHistory);